if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onModalKeydown = this.onModalKeydown.bind(this);
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.previousButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.currentCounter = this.querySelector('[data-product-modal-current]');
        this.totalCounter = this.querySelector('[data-product-modal-total]');

        [this.previousButton, this.nextButton].filter(Boolean).forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', () => this.changeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.changeMedia(1));
      }

      hide() {
        document.removeEventListener('keydown', this.onModalKeydown);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.addEventListener('keydown', this.onModalKeydown);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showActiveMedia() {
        const requestedId = this.openedBy?.getAttribute('data-media-id');
        const items = this.getMediaItems();
        if (!items.length) return;

        items.forEach((element) => element.classList.remove('active'));
        const activeMedia = items.find((element) => element.dataset.mediaId === requestedId) || items[0];
        this.activateMedia(activeMedia, false);
      }

      changeMedia(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;

        const activeMedia = items.find((element) => element.classList.contains('active')) || items[0];
        const currentIndex = Math.max(0, items.indexOf(activeMedia));
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activateMedia(items[nextIndex], true);
      }

      activateMedia(activeMedia, focusMedia = false) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => element.classList.toggle('active', element === activeMedia));
        window.pauseAllMedia();

        const activeMediaTemplate = activeMedia.querySelector?.('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        const container = this.querySelector('.product-media-modal__content');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        const items = this.getMediaItems();
        const position = Math.max(0, items.indexOf(activeMedia));
        if (this.currentCounter) this.currentCounter.textContent = String(position + 1);
        if (this.totalCounter) this.totalCounter.textContent = String(items.length);

        if (focusMedia) {
          const focusable = activeMedia.matches('img') ? this.nextButton : activeMedia.querySelector?.('button, [tabindex]');
          focusable?.focus?.({ preventScroll: true });
        }
      }

      onModalKeydown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.changeMedia(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.changeMedia(1);
        }
      }
    }
  );
}
